import React, { useMemo } from "react";
import styles from "./TestimonialsSection.module.css";
import TestimonialCard from "./TestimonialCard";
import TestimonialGallery from "./TestimonialGallery";
import StructuredData from "../components/StructuredData";
import { useTranslation } from "react-i18next";

const TestimonialsSection = ({ subtitleKey = 'TestimonialsSubtitle', badgeKey = null, compact = false }) => {

    const { t } = useTranslation();
  const badge = badgeKey ? t(badgeKey) : null;

  const testimonials = [
    {
      id: 1,
      name: "Kevin Fontaine",
      role: t("KFontaineTitle"),
      text: t("KFontaineTestimonial"),
      avatar: "/images/KFontaine.jpg",
    },    
  ];

  const reviewsSchema = useMemo(() => ({
    "@context": "https://schema.org",
    "@graph": testimonials.map((tst) => ({
      "@type": "Review",
      "itemReviewed": { "@type": "SoftwareApplication", "name": "UpReality" },
      "author": { "@type": "Person", "name": tst.name },
      "reviewBody": tst.text
    }))
  }), [t('KFontaineTestimonial'), t('KFontaineTitle')]);

  // Aligné sur le breakpoint HP tablet/mobile (BaseHomePage : max-width 1224px)
  // Sinon iPad portrait (ex. 820×1180) affiche le layout desktop large
  const isMobile = window.innerWidth <= 1224;

  return (
    <>
      <StructuredData id="testimonials-reviews" data={reviewsSchema} />
      <section className={styles.testimonialsContainer} style={{padding: isMobile ? "20px 16px" : (compact ? "28px 20px 40px" : "80px 20px 40px")}}>
        <header className={styles.testimonialsHeader} style={!isMobile ? { marginBottom: compact ? 46 : 80 } : undefined}>
          <h2 style={{fontSize: isMobile ? 22 : 26, fontWeight: "bold", textAlign: "center", color: "rgb(45, 55, 72)", margin: !isMobile ? (compact ? "18px 0 0" : 0) : undefined}}>{t('TestimonialsTitle')}</h2>
          <p className={styles.subtitle} style={{textAlign: "center", fontSize: isMobile ? 14 : 16}}>
          {t(subtitleKey)}
          </p>
        </header>

        {isMobile ? (
          // Version mobile : layout vertical
          <div style={{display: "flex", flexDirection: "column", alignItems: "center", gap: "24px"}}>
            <div className={styles.testimonialsGrid}>
              {testimonials.map((testimonial) => (
                <TestimonialCard
                  key={testimonial.id}
                  name={testimonial.name}
                  role={testimonial.role}
                  text={testimonial.text}
                  avatar={testimonial.avatar}
                  badge={badge}
                />
              ))}
            </div>
            <TestimonialGallery />
          </div>
        ) : (
          // Version desktop : layout horizontal
          <div style={{display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "flex-start", gap: "40px"}}>
            <div className={styles.testimonialsGrid}>
              {testimonials.map((testimonial) => (
                <TestimonialCard
                  key={testimonial.id}
                  name={testimonial.name}
                  role={testimonial.role}
                  text={testimonial.text}
                  avatar={testimonial.avatar}
                  badge={badge}
                  matchGalleryHeight
                />
              ))}
            </div>
            <div style={{display: "flex", flexDirection: "row", gap: "16px", alignItems: "flex-start"}}>
              <a
                href="https://upreality.store/p/CaffeCardito"
                target="_blank"
                rel="noopener noreferrer"
                style={{ display: "block", cursor: "pointer" }}
              >
                <img 
                  src="/images/temoignage1.webp" 
                  alt={t('TestimonialImageAlt', { num: 1 })} 
                  style={{
                    width: "202px",
                    height: "400px",
                    objectFit: "contain",
                    borderRadius: "20px",
                    boxShadow: "0 8px 20px rgba(0, 0, 0, 0.1)"
                  }}
                />
              </a>
              <img 
                src="/images/temoignage2.webp" 
                alt={t('TestimonialImageAlt', { num: 2 })} 
                style={{
                  width: "202px",
                  height: "400px",
                  objectFit: "contain",
                  borderRadius: "20px",
                  boxShadow: "0 8px 20px rgba(0, 0, 0, 0.1)"
                }}
              />
              <img 
                src="/images/temoignage3.webp" 
                alt={t('TestimonialImageAlt', { num: 3 })} 
                style={{
                  width: "202px",
                  height: "400px",
                  objectFit: "contain",
                  borderRadius: "20px",
                  boxShadow: "0 8px 20px rgba(0, 0, 0, 0.1)"
                }}
              />
            </div>
          </div>
        )}
      </section>
    </>
  );
};

export default TestimonialsSection;